import { TObject } from 'utils/types';

import {
  IBlacklistedEmail,
  IBlacklistedEmailData,
  ICardMasks,
  ICardMasksData,
  ICardPans,
  ICardPansData,
  ICreatedBy,
  IDevice,
  IDevicesData,
  IIpAddress,
  IIpAddressData,
} from './types';

export const normalizeCardMasks = (data: ICardMasksData): ICardMasks => {
  return {
    bin: (data?.bin as string) || '',
    createdBy: {
      login: (data?.createdBy?.login as string) || '',
    },
    createdOn: (data?.createdOn as string) || '',
    customer: {
      email: (data?.customer?.email as string) || '',
      firstName: (data?.customer?.firstName as string) || '',
      id: (data?.customer?.id as number) || 0,
      lastName: (data?.customer?.lastName as string) || '',
    },
    customerId: (data.customerId as string) || '',
    id: (data?.id as number) || 0,
    lastFour: (data?.lastFour as string) || '',
    merchant: {
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
      name: (data?.merchantTerminal?.name as string) || '',
    },
  };
};

export const normalizeCardPans = (data: ICardPansData): ICardPans => {
  return {
    cardNum: (data?.cardNum as string) || '',
    cardPanId: (data?.cardPanId as number) || 0,
    createdBy: (data?.createdBy as string) || '',
    createdOn: (data?.createdOn as string) || '',
    customer: {
      email: (data?.customer?.email as string) || '',
      firstName: (data?.customer?.firstName as string) || '',
      id: (data?.customer?.id as number) || 0,
      lastName: (data?.customer?.lastName as string) || '',
    },
    customerId: (data.customerId as string) || '',
    id: (data?.id as number) || 0,
    merchant: {
      enabled: !!data?.merchant?.enabled,
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
      name: (data?.merchantTerminal?.name as string) || '',
    },
  };
};

const normalizeCreatedBy = (data?: TObject): ICreatedBy => {
  return {
    created: (data?.created as string) || '',
    id: (data?.id as number) || 0,
    isActive: !!data?.isActive,
    login: (data?.login as string) || '',
    merchantTerminalId: (data?.merchantTerminalId as number) || 0,
    username: (data?.username as string) || '',
  };
};

export const normalizeEmails = (data: IBlacklistedEmailData): IBlacklistedEmail => {
  return {
    createdBy: normalizeCreatedBy(data?.createdBy),
    createdByNew: (data?.createdByNew as string) || '',
    createdOn: (data?.createdOn as string) || '',
    customer: {
      firstName: (data?.customer?.firstName as string) || '',
      id: (data?.customer?.id as number) || 0,
      lastName: (data?.customer?.lastName as string) || '',
    },
    customerId: (data?.customerId as string) || '',
    email: (data?.email as string) || '',
    id: (data?.id as number) || 0,
    merchant: {
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
      name: (data?.merchantTerminal?.name as string) || '',
    },
  };
};

export const normalizeIpAddress = (data: IIpAddressData): IIpAddress => {
  return {
    createdBy: normalizeCreatedBy(data?.createdBy),
    createdByNew: (data?.createdByNew as string) || '',
    createdOn: (data?.createdOn as string) || '',
    customer: {
      email: (data?.customer?.email as string) || '',
      firstName: (data?.customer?.firstName as string) || '',
      id: (data?.customer?.id as number) || 0,
      lastName: (data?.customer?.lastName as string) || '',
    },
    customerId: (data?.customerId as string) || '',
    id: (data?.id as number) || 0,
    ip: (data?.ip as string) || '',
    merchant: {
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
      name: (data?.merchantTerminal?.name as string) || '',
    },
  };
};

export const normalizeDevices = (data: IDevicesData): IDevice => {
  return {
    createdBy: (data?.createdBy as string) || '',
    createdOn: (data?.createdOn as string) || '',
    customer: {
      email: (data?.customer?.email as string) || '',
      firstName: (data?.customer?.firstName as string) || '',
      id: (data?.customer?.id as number) || 0,
      lastName: (data?.customer?.lastName as string) || '',
    },
    customerId: (data?.customerId as string) || '',
    fingerprint: (data?.fingerprint as string) || '',
    id: (data?.id as number) || 0,
    merchant: {
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
      name: (data?.merchantTerminal?.name as string) || '',
    },
  };
};
